import { useMutation } from '@tanstack/react-query'
import { request } from 'Lib/axios'
import { queryClient } from 'Lib/react-query'
import { useUserStore } from 'Stores/userStoreModuleFed'

const deleteAccountLogo = async () => {
  const accountId = useUserStore.getState().accountId

  return (await request({
    url: `accounts/${accountId}/setup/logo`,
    method: 'DELETE',
  })) as void
}

export const useDeleteAccountLogo = () =>
  useMutation(deleteAccountLogo, {
    onSuccess: () => {
      void queryClient.removeQueries(['accountLogo'])
    },
  })
